export enum QueryTerms {
    caretype = 'caretype',
    networkid = 'networkid',
    type = 'type',
    network = 'network',
    address = 'address',
    mileradius = 'mileradius',
    oldmileradius= 'oldmileradius',
    ismultispecialtysearch = 'ismultispecialtysearch',
    searchoption = 'searchoption',
    service = 'service',
    specialtytype = 'specialtytype',
    specialty = 'specialty',
    providername = 'providername',
    phoneNumber = 'phonenumber',
    providertype = 'providertype',
    isserviceareasearch = 'isserviceareasearch',
    altDestinationUrl = 'altDestinationUrl',
    searchYear = 'searchYear',
    people = 'people',
    places = 'places',
    acceptingnewpatients = 'acceptingnewpatients',
    // lgbtqia = 'lgbtqia',
    eveninghours = 'eveninghours',
    weekendhours = 'weekendhours',
    handicapaccess = 'handicapaccess',
    telehealth = 'telehealth',
    accreditedfacility = 'accreditedfacility',
    subproductkey = 'subproductkey',
    plandisplaykey = 'plandisplaykey',
    language = 'language',
    gender = 'gender',
    hospitalprivilege = 'hospitalprivilege',
    page = 'page',
    level = 'level',
    pos = 'pos',
    sortType = 'sortType',
    drugId = 'drugId',
    drugName = 'drugName',
    benefitYear = 'benefitYear',
    formularyId = 'formularyId',
    id = 'id',
    location = 'location',
    loginType = 'loginType'
}

export enum BrowseTypes {
    find = 'find',
    shop = 'shop',
    employer = 'employer',
}

export enum PageTypes {
    find = 'find',
    browse = 'browse',
    search = 'search',
    findpcp = 'findpcp',
    medication = 'medication',
    employergroup = 'employergroup'
}

export enum NetworkTypes {
    Cigna = 'Cigna Extended Network'
}